import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHongKong = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_346)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.2389 9.07819C12.9661 10.2125 12.4816 9.99619 12.2438 10.9854C10.843 10.6486 9.98034 9.24005 10.3171 7.83919C10.6538 6.43842 12.0625 5.57573 13.4633 5.91253C12.9877 7.89099 13.4828 8.06367 13.2389 9.07819Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.60408 9.91875C10.5986 10.5286 10.2431 10.9227 11.1104 11.4546C10.3572 12.6827 8.75104 13.0678 7.52283 12.3147C6.29465 11.5615 5.90948 9.95527 6.66267 8.7271C8.39733 9.79078 8.71444 9.37327 9.60408 9.91875Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.28019 13.6356C10.1676 12.8782 10.4324 13.338 11.2062 12.6775C12.1416 13.7733 12.0115 15.4199 10.9158 16.3553C9.81991 17.2907 8.17329 17.1605 7.23804 16.0648C8.78557 14.7437 8.48646 14.3129 9.28019 13.6356Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.715 15.0921C12.2688 14.0141 12.7879 13.9042 12.3989 12.9643C13.7301 12.4133 15.256 13.0459 15.807 14.3771C16.3579 15.7083 15.7253 17.2341 14.3941 17.7851C13.6161 15.905 13.1141 16.0563 12.715 15.0921Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1618 12.2754C13.9987 12.3667 14.0545 11.8389 13.0403 11.9185C12.9277 10.4823 14.0009 9.22645 15.4372 9.11372C16.8734 9.00127 18.1292 10.0743 18.2418 11.5107C16.2132 11.6697 16.202 12.1939 15.1618 12.2754Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_346",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgHongKong;
